export default __webpack_public_path__ + "static/IMAGEM_1-3fa366ada089f5fe9edc3e938c45458f.png";